import * as Common from '@/tenant/common';

export class Component extends Common.MasterBase{
  constructor(){
    super('Component');
    this.binders.commodity = new Common.ModelBinder(Common.Commodity);
    this.binders.sku = new Common.ModelBinder(Common.SKU);
    this.state = Common.MasterBaseStatus.NotPosted;
    this.workflowStateId = Common.MasterBaseStatus.NotPosted;
  }
  public id: number = 0;
  public assemblyId: number = 0;
  public assembly: Common.Assembly  = null;
  public componentCommodityId: number = 0;
  public componentCommodity: Common.Commodity = null;
  public skuId: number = 0;
  public sku: Common.SKU = null;

  // 予備項目
  public reserveText1: string  = '';
  public reserveText2: string  = '';
  public reserveText3: string  = '';
  public reserveText4: string  = '';
  public reserveText5: string  = '';
  public reserveText6: string  = '';
  public reserveMemo1: string  = '';
  public reserveMemo2: string  = '';
  public reserveMemo3: string  = '';
  public reserveDate1: Date  = null;
  public reserveDate2: Date  = null;
  public reserveDate3: Date  = null;
  public reserveList1: number  = null;
  public reserveList2: number  = null;
  public reserveList3: number  = null;
  public componentQuantity: number = 0;
  public divideReferencePrice: number = 0;

  public limitQuantity: number = 0;

  public copy():any {
    const temp = super.copy() as Component;
    temp.id = 0;
    temp.state = Common.MasterBaseStatus.NotPosted;
    temp.workflowStateId = Common.MasterBaseStatus.NotPosted;
    return temp;
  }
}

export class ComponentQuery extends Common.LoadQuery {
  constructor(){
    super('ComponentQuery',Component);
    this.sort = 'assembly';
  }
  public commodity : Common.Commodity = null;
  public sku: Common.SKU = null;
  public assembly: Common.Assembly = null;
  public assemblyId :number = null; //セット品マスタの構成品タブ用
  // public assemblyName: string = '';
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.MasterBaseStatus = null;
  public holder: string = '';
  public auditNo: string ='';
}